import { MutationTree, GetterTree } from 'vuex';
import { ICubeJsState } from './types';
const state: ICubeJsState = {
	loadingCubeJsTokenStarting: false,
	loadingCubeJsTokenSuccess: false,
	loadingCubeJsTokenFailure: undefined,
	tokenList: {}
};

const mutations: MutationTree<ICubeJsState> = {
	loadingCubeJsTokenStart(cubeJsState: ICubeJsState): void {
		cubeJsState.loadingCubeJsTokenStarting = true;
		cubeJsState.loadingCubeJsTokenSuccess = false;
		cubeJsState.loadingCubeJsTokenFailure = undefined;
	},

	loadingCubeJsTokenSuccess(cubeJsState: ICubeJsState): void {
		cubeJsState.loadingCubeJsTokenStarting = false;
		cubeJsState.loadingCubeJsTokenSuccess = true;
		cubeJsState.loadingCubeJsTokenFailure = undefined;
	},
	loadingCubeJsTokenFailure(cubeJsState: ICubeJsState, error: unknown): void {
		cubeJsState.loadingCubeJsTokenStarting = false;
		cubeJsState.loadingCubeJsTokenSuccess = false;
		cubeJsState.loadingCubeJsTokenFailure = error;
	},
	setCubeJsToken(cubeJsState: ICubeJsState, customerToken: { idCustomer: string, token: string }): void {
		cubeJsState.tokenList[customerToken.idCustomer] = customerToken.token;
	}
};

const getters: GetterTree<ICubeJsState, unknown> = {
	customerToken(cubeJsState: ICubeJsState): (idCustomer: string) => string | undefined {
		return (idCustomer: string) => cubeJsState.tokenList[idCustomer];
	}
};

export const cubeJsStore = {
	namespaced: true,
	state,
	mutations,
	getters
};
